import { getFavouritesFromCookie } from "./helpers";
import { ActionTypes, State } from "./types";

const { opportunities, organisations } = getFavouritesFromCookie();

export const reducer = (
  state: State = {
    opportunities,
    organisations,
    loading: false,
    error: false,
  },
  action: ActionTypes
): State => {
  let newState;

  switch (action.type) {
    case "FAVOURITES:FETCH:START":
      return {
        ...state,
        loading: true,
        error: false,
      };
    case "FAVOURITES:FETCH:END":
      return {
        ...state,
        loading: false,
        error: false,
        organisations: action.payload.organisations,
        opportunities: action.payload.opportunities,
      };
    case "FAVOURITES:ORG:ADD":
      return {
        ...state,
        organisations: {
          ...state.organisations,
          [action.payload.id]: Date.now(),
        },
      };
    case "FAVOURITES:OPP:ADD":
      return {
        ...state,
        opportunities: {
          ...state.opportunities,
          [action.payload.id]: Date.now(),
        },
      };
    case "FAVOURITES:ORG:REMOVE":
      newState = Object.assign({}, state);
      delete newState.organisations[action.payload.id];
      return newState;
    case "FAVOURITES:OPP:REMOVE":
      newState = Object.assign({}, state);
      delete newState.opportunities[action.payload.id];
      return newState;
    default:
      return state;
  }
};
